import React from "react";
import CreditReportManagement from "../shared/CreditReportManagement";
import OrgUserAuthService from "../../../services/orgUserAuth.service";

export default function OrgUserCreditReports() {
  return (
    <CreditReportManagement 
      role="orguser" 
      authService={OrgUserAuthService}
    />
  );
}
